type KeyBinding = {
  key: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  metaKey?: boolean;
  altKey?: boolean;
};

const BLOCKED_KEY_BINDINGS: KeyBinding[] = [
  // Windows / Linux (Ctrl-based)
  { key: 'F12' },
  { key: 'I', ctrlKey: true, shiftKey: true },
  { key: 'J', ctrlKey: true, shiftKey: true },
  { key: 'C', ctrlKey: true, shiftKey: true },
  { key: 'K', ctrlKey: true, shiftKey: true },
  { key: 'U', ctrlKey: true },
  // macOS — Chrome, Brave, Firefox, Safari (Cmd+Option+*)
  // macOS fires lowercase e.key for Cmd+Option+letter combos
  { key: 'i', metaKey: true, altKey: true },
  { key: 'j', metaKey: true, altKey: true },
  { key: 'c', metaKey: true, altKey: true },
  { key: 'k', metaKey: true, altKey: true },
  { key: 'u', metaKey: true },
];

// Docked DevTools open at least this many px of window chrome on one side.
const DEVTOOLS_SIZE_THRESHOLD = 160;

let heartbeatId: ReturnType<typeof setInterval> | null = null;
let overlayEl: HTMLDivElement | null = null;

function handleKeyDown(e: KeyboardEvent): void {
  const blocked = BLOCKED_KEY_BINDINGS.some(
    (b) =>
      e.key === b.key &&
      (b.ctrlKey === undefined || e.ctrlKey === b.ctrlKey) &&
      (b.shiftKey === undefined || e.shiftKey === b.shiftKey) &&
      (b.metaKey === undefined || e.metaKey === b.metaKey) &&
      (b.altKey === undefined || e.altKey === b.altKey),
  );
  if (blocked) {
    e.preventDefault();
    e.stopPropagation();
  }
}

function handleContextMenu(e: MouseEvent): void {
  e.preventDefault();
}

function isDevToolsOpen(): boolean {
  return (
    window.outerWidth - window.innerWidth > DEVTOOLS_SIZE_THRESHOLD ||
    window.outerHeight - window.innerHeight > DEVTOOLS_SIZE_THRESHOLD
  );
}

function showOverlay(): void {
  if (overlayEl) return;
  const el = document.createElement('div');
  el.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:2147483647',
    'background:rgba(0,0,0,0.92)',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'color:#fff',
    'font-family:sans-serif',
    'font-size:1.125rem',
    'text-align:center',
    'user-select:none',
    'padding:2rem',
  ].join(';');
  el.textContent = 'Developer tools detected. Please close them to continue.';
  document.body.appendChild(el);
  overlayEl = el;
}

function hideOverlay(): void {
  const el = overlayEl;
  if (!el) return;
  document.body.removeChild(el);
  overlayEl = null;
}

function startHeartbeat(): void {
  heartbeatId = setInterval(() => {
    if (isDevToolsOpen()) {
      showOverlay();
    } else {
      hideOverlay();
    }
  }, 1000);
}

export function activateDevToolsProtection(): () => void {
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('contextmenu', handleContextMenu);
  startHeartbeat();
  return deactivateDevToolsProtection;
}

export function deactivateDevToolsProtection(): void {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('contextmenu', handleContextMenu);
  if (heartbeatId !== null) {
    clearInterval(heartbeatId);
    heartbeatId = null;
  }
  hideOverlay();
}
